import { joinWithComma } from '../../../common/helpers/joinWithComma.helper';
import { theme } from '../../../common/ui/theme';

interface SelectStylesOptions {
    positive?: boolean;
    negative?: boolean;
}

export const getSelectControlStyles = (
    state: any,
    options: SelectStylesOptions
): {
    backgroundColor: string;
    boxShadow: string;
    hoverBoxShadow: string;
} => {
    if (state.isDisabled) {
        return {
            backgroundColor: theme.colors.background.subtle,
            boxShadow: theme.shadows.border.disabled,
            hoverBoxShadow: theme.shadows.border.disabled,
        };
    }

    if (state.isFocused || state.menuIsOpen) {
        if (options.negative) {
            const shadow = joinWithComma(theme.shadows.border.negative, theme.shadows.focus);
            return {
                backgroundColor: theme.colors.background.default,
                boxShadow: shadow,
                hoverBoxShadow: shadow,
            };
        }

        if (options.positive) {
            const shadow = joinWithComma(theme.shadows.border.positive, theme.shadows.focus);
            return {
                backgroundColor: theme.colors.background.default,
                boxShadow: shadow,
                hoverBoxShadow: shadow,
            };
        }

        const shadow = joinWithComma(theme.shadows.focus, theme.shadows.border.default);
        return {
            backgroundColor: theme.colors.background.default,
            boxShadow: shadow,
            hoverBoxShadow: shadow,
        };
    }

    if (options.negative) {
        return {
            backgroundColor: theme.colors.background.default,
            boxShadow: joinWithComma(theme.shadows.border.negative, theme.shadows.select.base),
            hoverBoxShadow: joinWithComma(theme.shadows.border.negative, theme.shadows.select.hover),
        };
    }

    if (options.positive) {
        return {
            backgroundColor: theme.colors.background.default,
            boxShadow: joinWithComma(theme.shadows.border.positive, theme.shadows.select.base),
            hoverBoxShadow: joinWithComma(theme.shadows.border.positive, theme.shadows.select.hover),
        };
    }

    return {
        backgroundColor: theme.colors.background.default,
        boxShadow: joinWithComma(theme.shadows.select.base, theme.shadows.border.default),
        hoverBoxShadow: joinWithComma(theme.shadows.select.hover, theme.shadows.border.default),
    };
};
